export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_REQUEST_SUCCEEDED = "SIGNUP_REQUEST_SUCCEEDED";
export const SIGNUP_REQUEST_FAILED = "SIGNUP_REQUEST_FAILED";
